import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { MustMatch } from 'src/app/data-service/must-match.validator';

@Component({
  selector: 'app-add-slave-admin',
  templateUrl: './add-slave-admin.component.html',
  styleUrls: ['./add-slave-admin.component.scss']
})
export class AddSlaveAdminComponent implements OnInit {
  isEditing: boolean;
  menu_id: any;
  form: FormGroup;
  form1: FormGroup;
  public role: any;
  public roleName: string;
  menuList: any = [];
  somePlaceholder: string = "new value";
  questions: any = []
  sAdminAccess: any = [];
  userId: any;
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private dashboardService: DashboardService,
    private toastr: ToastrService) {

    this.route.queryParams.subscribe(params => {
      if (params.id && params.is_Editing) {
        this.isEditing = params.is_Editing;
        this.userId = params.id;
        this.getSlaveAdminById(this.userId)
      }
    });
    this.role = localStorage.role;

    this.form = this.fb.group({});

    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }
  }

  ngOnInit() {
    this.form1 = this.fb.group({
      // login id, name, address, comp_nm,con_nm pattern to accept digit, letter, special char
      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      email: ['', [Validators.required, Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]],
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    }
    );
    if (this.roleName == 'admin' &&  !this.isEditing ) {
      this.getAllMenu();
    }
  }

  get f() { return this.form1.controls; }
  getSlaveAdminById(id) {
    var MenuObj = {
      slaveadmin_id: id,
    }
    this.dashboardService.getSlaveAdminById(MenuObj)
      .subscribe(
        async result => {
          if (result.status) {
            this.form1.patchValue({
              login_id: result.resultObject.login_id,
              name: result.resultObject.name,
              email: result.resultObject.email,
              mobile_no: result.resultObject.mobile_no,
              address: result.resultObject.address,
              password: 'rahul@123',
              confirmPassword: 'rahul@123',
            });
            // this.form.get("login_id").patchValue(address);
            this.menuList= result.resultObject.SadminAccess
            this.menuList.forEach((question, index) => {
              this.form.addControl(question.id, this.fb.control(question.id, Validators.required));
              this.form.addControl("access" + question.id, this.fb.control(null, Validators.required));
              this.form.get("access" + question.id).patchValue(question.access);
            })
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  getAllMenu() {
    var MenuObj = {
      "search": "",
      "limit": "10",
      "offset": "0"
    }
    this.dashboardService.getAllMenu(MenuObj)
       .subscribe(
        async result => {
          if (result.status) {
              this.menuList = result.resultObject;
              this.menuList.forEach((question, index) => {
              this.form.addControl(question.id, this.fb.control(question.id, Validators.required));
              this.form.addControl("access" + question.id, this.fb.control("2", Validators.required));
            })
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  addSlaveAdmin() {
    this.sAdminAccess = [];
    var months: { [key: string]: string } = this.form.value;
    var menu = [];
    var access = [];
    for (let i = 0; i < Object.values(months).length; i++) {
      if (i < Object.values(months).length / 2) {
        menu.push({ menu_id: Object.values(months)[i] })
      } else {
        access.push({ access: Object.values(months)[i] })
      }
    }
    for (let i = 0; i < menu.length; i++) {
      this.sAdminAccess.push({ menu_id: menu[i].menu_id, access: access[i].access });
    }
    var addSlaveAdmin = {
      login_id: this.form1.value.login_id,
      name: this.form1.value.name,
      email: this.form1.value.email,
      password: this.form1.value.password,
      mobile_no: this.form1.value.mobile_no,
      address: this.form1.value.address,
      SadminAccess: this.sAdminAccess
    }
    this.dashboardService.addSlaveAdmin(addSlaveAdmin)
      .subscribe(
        async result => {
          if (result.status) {
            this.toastr.success(result.message);
            this.router.navigate(['/inject-solar/slave-admin']);
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  updateSlaveAdmin() {
    this.sAdminAccess = [];
    var months: { [key: string]: string } = this.form.value;
    var menu = [];
    var access = [];
    for (let i = 0; i < Object.values(months).length; i++) {
      if (i < Object.values(months).length / 2) {
        menu.push({ menu_id: Object.values(months)[i] })
      } else {
        access.push({ access: Object.values(months)[i] })
      }
    }
    for (let i = 0; i < menu.length; i++) {
      this.sAdminAccess.push({ menu_id: menu[i].menu_id, access: access[i].access });
    }
    var addSlaveAdmin = {
      slaveadmin_id:this.userId,
      login_id: this.form1.value.login_id,
      name: this.form1.value.name,
      email: this.form1.value.email,
      mobile_no: this.form1.value.mobile_no,
      address: this.form1.value.address,
      SadminAccess: this.sAdminAccess
    }
    this.dashboardService.updateSlaveAdmin(addSlaveAdmin)
       .subscribe(
        async result => {
          if (result.status) {
            this.toastr.success(result.message);
            this.router.navigate(['/inject-solar/slave-admin']);
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
}
